
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-services/[[...path]]",
      function () {
        return require("private-next-pages/our-services/[[...path]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-services/[[...path]]"])
      });
    }
  